import { Injectable } from '@angular/core';
import { GameEntityType } from '../../../../../common/dto/game-entities.dto';
import { CoolHttp } from '@angular-cool/http';
import { ServerUrls } from '../../../../../common/dto/server-urls';
import { FileUploadRequestUtils } from '../utils/file-upload-request.utils';
import { PCacheable, PCacheBuster } from 'ts-cacheable';
import { Subject } from 'rxjs';
import {
  GameEntityTemplateFullDTO,
  GameEntityTemplateId,
  GameEntityTemplateMinimalDTO,
} from '../../../../../common/dto/game-entitie-templates.dto';
import { MINUTE_IN_MILLISECONDS } from '../../../../../common/utils/date.utils';

const gameEntityTemplateCacheBuster$ = new Subject<void>();

@Injectable()
export class GameEntityTemplatesService {
  constructor(private _http: CoolHttp) {}

  public async getGameEntityTemplateByIdAsync(
    gameEntityTemplateId: GameEntityTemplateId,
  ): Promise<GameEntityTemplateFullDTO> {
    return await this._http.getAsync(
      ServerUrls.GameEntityTemplates.children.GetById.getAbsoluteUrlWithParams({
        [ServerUrls.GameEntityTemplates.children.GetById.params.gameEntityTemplateId]: gameEntityTemplateId,
      }),
    );
  }

  @PCacheable({
    maxAge: 5 * MINUTE_IN_MILLISECONDS,
    cacheBusterObserver: gameEntityTemplateCacheBuster$,
  })
  public async getGameEntityTemplatesAsyncCACHED(type: GameEntityType): Promise<GameEntityTemplateMinimalDTO[]> {
    return await this._http.getAsync(
      ServerUrls.GameEntityTemplates.children.Get.getAbsoluteUrlWithQuery({
        [ServerUrls.GameEntityTemplates.children.Get.queryParams.type]: type,
      }),
    );
  }

  @PCacheBuster({
    cacheBusterNotifier: gameEntityTemplateCacheBuster$,
  })
  public async upsertGameEntityTemplateAsync(
    gameEntityTemplate: GameEntityTemplateFullDTO,
  ): Promise<GameEntityTemplateFullDTO> {
    const formData = FileUploadRequestUtils.createRequestForm('template', gameEntityTemplate, [
      {
        name: 'image',
        resolver: _ => _.image,
      },
    ]);

    return await this._http.postAsync(ServerUrls.GameEntityTemplates.children.Upsert.absoluteUrl, formData);
  }

  public async removeGameEntityTemplateAsync(gameEntityTemplateId: GameEntityTemplateId) {
    await this._http.deleteAsync(
      ServerUrls.GameEntityTemplates.children.DeleteById.getAbsoluteUrlWithParams({
        [ServerUrls.GameEntityTemplates.children.DeleteById.params.gameEntityTemplateId]: gameEntityTemplateId,
      }),
    );
  }
}
